// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import {
  BaseQueryFn,
  createApi,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError
} from '@reduxjs/toolkit/query/react';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

// initialize an empty api service that we'll inject endpoints into later as needed

const dynamicBaseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, WebApi, extraOptions) => {
  let baseUrl = `https://${cookies.get('tenantSubDomain')}.${cookies.get(
    'apiBaseDomain'
  )}`;

  if (process.env.REACT_APP_BYPASS === '1') {
    baseUrl = process.env.REACT_APP_API_FULL_URI || '';
  }

  const rawBaseQuery = fetchBaseQuery({
    baseUrl,
    credentials: 'include',
    prepareHeaders: (headers, { getState }) => {
      const userInfo = cookies.get('userInfo');
      if (userInfo) {
        headers.set('x-experiencelab-user-name', userInfo.name);
      }
      return headers;
    }
    // paramsSerializer: (params) => {
    //   return params;
    // }
  });
  return rawBaseQuery(args, WebApi, extraOptions);
};

export const emptySplitApi = createApi({
  baseQuery: dynamicBaseQuery,
  // credentials: 'include',
  endpoints: () => ({}),
  keepUnusedDataFor: 5,
  refetchOnMountOrArgChange: true
});
